import * as AssociateInformation from "./WorkersCompensation/AssociateInformation";
import * as IncidentTimeAndPlace from "./WorkersCompensation/IncidentTimeAndPlace";
import * as IncidentInformation from "./WorkersCompensation/IncidentInformation";
import * as PhysicianInformation from "./WorkersCompensation/PhysicianInformation";
import * as FileAttachments from "./WorkersCompensation/FileAttachments";
import * as Notifications from "./WorkersCompensation/Notifications";
import * as SiteConfiguration from "./WorkersCompensation/SiteConfigurationForm";
import * as AdditionalInformation from "./IPL/Step4/AdditionalInformation";

import * as BusinessDetails from "./Cargo/Stage1/BusinessDetails";
import * as IncidentDetails from "./Cargo/Stage1/IncidentDetails";
import * as ShipmentDetails from "./Cargo/Stage1/ShipmentDetails";
import * as ClaimDetails from "./Cargo/Stage2/ClaimDetails";
import * as CargoFileAttachments from "./Cargo/Stage3/FileAttachments";

import * as ClaimValidation from "./IPL/Step1/ClaimValidation";
import * as ProductInformation from "./IPL/Step2/ProductInformation";
import * as ClaimInformation from "./IPL/Step3/ClaimInformation";
import * as IPLFileAttachments from "./IPL/Step5/FileAttachments";

import { AllFormsType } from "./types";

export const allForms: AllFormsType = {
  [AssociateInformation.formName]: {
    formState: AssociateInformation.formState,
    formConfig: AssociateInformation.formConfig,
    formValidation: AssociateInformation.formValidation,
  },
  [IncidentTimeAndPlace.formName]: {
    formState: IncidentTimeAndPlace.formState,
    formConfig: IncidentTimeAndPlace.formConfig,
    formValidation: IncidentTimeAndPlace.formValidation,
  },
  [IncidentInformation.formName]: {
    formState: IncidentInformation.formState,
    formConfig: IncidentInformation.formConfig,
    formValidation: IncidentInformation.formValidation,
  },
  [PhysicianInformation.formName]: {
    formState: PhysicianInformation.formState,
    formConfig: PhysicianInformation.formConfig,
    formValidation: PhysicianInformation.formValidation,
  },
  [FileAttachments.formName]: {
    formState: FileAttachments.formState,
    formConfig: FileAttachments.formConfig,
    formValidation: FileAttachments.formValidation,
  },
  [Notifications.formName]: {
    formState: Notifications.formState,
    formConfig: Notifications.formConfig,
    formValidation: Notifications.formValidation,
  },
  [SiteConfiguration.formName]: {
    formState: SiteConfiguration.formState,
    formConfig: SiteConfiguration.formConfig,
    formValidation: SiteConfiguration.formValidation,
  },
  [BusinessDetails.formName]: {
    formState: BusinessDetails.formState,
    formConfig: BusinessDetails.formConfig,
    formValidation: BusinessDetails.formValidation,
  },
  [ShipmentDetails.formName]: {
    formState: ShipmentDetails.formState,
    formConfig: ShipmentDetails.formConfig,
    formValidation: ShipmentDetails.formValidation,
  },
  [IncidentDetails.formName]: {
    formState: IncidentDetails.formState,
    formConfig: IncidentDetails.formConfig,
    formValidation: IncidentDetails.formValidation,
  },
  [ClaimDetails.formName]: {
    formState: ClaimDetails.formState,
    formConfig: ClaimDetails.formConfig,
    formValidation: ClaimDetails.formValidation,
  },
  [CargoFileAttachments.formName]: {
    formState: CargoFileAttachments.formState,
    formConfig: CargoFileAttachments.formConfig,
    formValidation: CargoFileAttachments.formValidation,
  },
  [ProductInformation.formName]: {
    formState: ProductInformation.formState,
    formConfig: ProductInformation.formConfig,
    formValidation: ProductInformation.formValidation,
  },
  [ClaimValidation.formName]: {
    formState: ClaimValidation.formState,
    formConfig: ClaimValidation.formConfig,
    formValidation: ClaimValidation.formValidation,
  },
  [ClaimInformation.formName]: {
    formState: ClaimInformation.formState,
    formConfig: ClaimInformation.formConfig,
    formValidation: ClaimInformation.formValidation,
  },
  [AdditionalInformation.formName]: {
    formState: AdditionalInformation.formState,
    formConfig: AdditionalInformation.formConfig,
    formValidation: AdditionalInformation.formValidation,
  },
  [IPLFileAttachments.formName]: {
    formState: IPLFileAttachments.formState,
    formConfig: IPLFileAttachments.formConfig,
    formValidation: IPLFileAttachments.formValidation,
  },
};
export const workersCompensationForms = {
  [AssociateInformation.formName]: allForms[AssociateInformation.formName],
  [IncidentTimeAndPlace.formName]: allForms[AssociateInformation.formName],
  [IncidentInformation.formName]: allForms[IncidentInformation.formName],
  [PhysicianInformation.formName]: allForms[PhysicianInformation.formName],
  [FileAttachments.formName]: allForms[FileAttachments.formName],
  [Notifications.formName]: allForms[Notifications.formName],
};
